import images from './images'
import React from 'react'
import './Pictures.scss'
import { useParams } from 'react-router-dom'
import P404 from '../../404/404'

const years = ["2024", "2025"]
interface PictureProps {
	lang: String
}
const Pictures: React.FC<PictureProps> = (props: PictureProps) => {
	const {year} = useParams<string>()
	if (!year || !years.some(y => y===year)) {
		return <P404 lang={props.lang}></P404>
	}
	const show = (path: string) => {
		document.getElementById('large-image')?.setAttribute('src', `${process.env.PUBLIC_URL}/images/editions/${year}/large/` + path);
		const div = document.getElementById('large-image-div');
		if (div) div.onclick = function () {
			div.style.visibility = 'hidden';
			document.getElementById('large-image')?.setAttribute('src', '');
		}
		if(div) div.style.visibility = 'visible';
	}

	return (<div className='pictures'>
		<div className="edition-images">
			{images[year].map((filename, index) => (
				<img alt={'image: ' + filename} onClick={() => show(filename)} className='edition-image' key={index} src={`${process.env.PUBLIC_URL}/images/editions/${year}/` + filename}></img>
			))}
		</div>
		<div className="edition-image-large-div">
			<div className="element" id="large-image-div">
				<div>
					<div className="close" id="close">X</div>
					<img className="edition-image-large" id="large-image" alt=""></img>
				</div>
			</div>
		</div>
	</div>)
}

export default Pictures